import { useEffect, useState } from "react";

/**
 * Tracks whether the page is hidden (e.g. browser tab is inactive or
 * window is minimized) using the Page Visibility API.
 */
export function usePageHidden(): boolean {
    const [isHidden, setIsHidden] = useState(false);

    useEffect(() => {
        const onChange = () => setIsHidden(document.hidden);
        document.addEventListener("visibilitychange", onChange);
        return () => document.removeEventListener("visibilitychange", onChange);
    }, []);

    return isHidden;
}
